import { render, staticRenderFns } from "./user-center-culture.vue?vue&type=template&id=280b1bef&scoped=true"
import script from "./user-center-culture.vue?vue&type=script&lang=js"
export * from "./user-center-culture.vue?vue&type=script&lang=js"
import style0 from "./user-center-culture.vue?vue&type=style&index=0&id=280b1bef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b1bef",
  null
  
)

export default component.exports